import { useState, useEffect } from "react";

const Fireworks = () => {
  const [explosions, setExplosions] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const id = Math.random();
      setExplosions((prev) => [
        ...prev,
        {
          id,
          x: Math.random() * window.innerWidth,
          y: Math.random() * window.innerHeight * 0.6 + 50,
        },
      ]);

      setTimeout(() => {
        setExplosions((prev) => prev.filter((exp) => exp.id !== id));
      }, 1200);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={fireworksContainerStyle}>
      {explosions.map((exp) => (
        <Explosion key={exp.id} x={exp.x} y={exp.y} />
      ))}
    </div>
  );
};

const Explosion = ({ x, y }) => {
  const particles = Array.from({ length: 25 });
  const colors = [
    "#FF0000",
    "#FF8C00",
    "#FFD700",
    "#00FF00",
    "#00CED1",
    "#1E90FF",
    "#8A2BE2",
  ];

  return (
    <div style={{ position: "absolute", top: y, left: x }}>
      {particles.map((_, i) => {
        const angle = (i / particles.length) * Math.PI * 2;
        const distance = 60 + Math.random() * 40;
        const color = colors[Math.floor(Math.random() * colors.length)];
        const delay = Math.random() * 0.5; // Some particles delay slightly for realistic effect

        return (
          <div
            key={i}
            style={{
              ...particleStyle,
              backgroundColor: color,
              transform: `translate(${Math.cos(angle) * distance}px, ${Math.sin(angle) * distance}px)`,
              animation: `explode 1s ease-out ${delay}s forwards`,
            }}
          />
        );
      })}
      <style>
        {`
          @keyframes explode {
            0% {
              opacity: 1;
              transform: scale(0.5);
            }
            50% {
              opacity: 1;
              transform: scale(1.2);
            }
            100% {
              opacity: 0;
              transform: scale(1.5);
            }
          }
        `}
      </style>
    </div>
  );
};

const fireworksContainerStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  overflow: "hidden",
  pointerEvents: "none",
};

const particleStyle = {
  position: "absolute",
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  opacity: 1,
};

export default Fireworks;
